import { doc, updateDoc } from "firebase/firestore";
import { modelsTestRef } from "../services/database";

export async function sendModelQuery(data) {
    await updateDoc(doc(modelsTestRef, "llava"), { ...data, updatedAt: Date.now() })
    return Promise.resolve()
}